export interface MaterialDetail {
  description: string;
  material: string;
  category?: string;
  searchText?: string;
  notes?: string;
  warehouseDetails?: WarehouseDetail[];
}

export interface WarehouseDetail {
  avgCost: number;
  backOrder: unknown;
  freezeInventory: string;
  inCo: number;
  lastCost: number;
  listPrice: number;
  loc: string;
  onHand: number;
  onOrder: number;
  packed: number;
  picked: number;
  rsvd: number;
  shipped: number;
  subLocationData: OrderSubLocation[];
  totalInProcess: unknown;
  warehouse: string;
}

export interface OrderSubLocation {
  subLocationId?: number;
  subLocationInvId?: number;
  subLocationName: string;
  onHand: number;
  inProcess: number;
}

export interface MaterialSubLocation {
  material: string;
  loc: string;
  company: number;
  subLocations: OrderSubLocation[];
}
